module.exports = __webpack_public_path__ + "web/img/shipping.1e0ef33b.png";